<div class="modal-header modalHeaderBlack">
  <h6 class="modal-title">{{ "DocumentUpload.documentUpload" | translate }}</h6>
  <span
    aria-label="Close"
    class="close"
    (click)="onNoClick()"
    data-automation-attribute="span-close-dialog"
  >
    <mat-icon matTooltip="{{ 'AddInternalNotes.close' | translate }}"
      >clear</mat-icon
    >
  </span>
</div>

<div>
  <div style="margin: 7px">
    <input type="file" id="fileUpload" style="display: none" />
    <div class="file-table">
      <table
        mat-table
        [dataSource]="fileSource"
        class="mat-elevation-z8"
        
      >
        <ng-container matColumnDef="docType">
          <th mat-header-cell *matHeaderCellDef >
            {{ "DocumentUpload.documentType" | translate }}
            <span class="red">*</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field class="full-width"  appearance="outline" >
              <mat-select [(ngModel)]="element.doctype" [disabled]="element.isOldFile"
             > 
              <mat-option>None</mat-option>
                 <mat-option *ngFor="let type of docList" [value]="type.code">
                   {{type.desc}}
                 </mat-option>
               </mat-select>
             </mat-form-field> 
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="documentType">
          <th mat-header-cell *matHeaderCellDef >
            {{ "DocumentUpload.documentType" | translate }}
            <span class="red">*</span>
          </th>
          <td mat-cell *matCellDef="let element; let index = index">
            <mat-select
              [(ngModel)]="element.fileType"
              [required]="true"
              [disabled]="element.isOld"
              (selectionChange)="upadteFileList(element.fileType, element)"
              class="table-text full-width"
            >
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="docTypeSearch"
                  [placeholderLabel]="'RegistrationPage.search' | translate"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option>{{"RegistrationPage.none" | translate}}</mat-option>
              <mat-option
                *ngFor="let option of docTypeFilteredList"
                [value]="option.code"
              >
                {{ option.desc }}
              </mat-option>
            </mat-select>
          </td>
        </ng-container> -->
        <ng-container matColumnDef="docName">
          <th mat-header-cell *matHeaderCellDef >
            {{ "DocumentUpload.documentName" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <input
            type="text"
            [(ngModel)]="element.fileDescription"
            [disabled]="element.isOldFile"
            name="fileDescription"
            pattern="[a-zA-Z0-9]+"
          />
          </td>
        </ng-container>

        <ng-container matColumnDef="fileName">
          <th mat-header-cell *matHeaderCellDef >
            {{ "DocumentUpload.fileName" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.fileName }}</td>
        </ng-container>

        <ng-container matColumnDef="fileType">
          <th mat-header-cell *matHeaderCellDef >
            {{ "DocumentUpload.fileType" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-select
              [(ngModel)]="element.fileType"
              [required]="true"
              [disabled]="element.isOldFile"
              (selectionChange)="upadteFileList(element.fileType, element)"
              class="table-text full-width"
            >
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="docTypeSearch"
                  [placeholderLabel]="'RegistrationPage.search' | translate"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option>{{"RegistrationPage.none" | translate}}</mat-option>
              <mat-option
                *ngFor="let option of documentTypelist"
                [value]="option.code"
              >
                {{ option.desc }}
              </mat-option>
            </mat-select>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>
            {{ "DocumentUpload.action" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="center">
              <mat-icon
                  *ngIf="element.isOldFile"
                  style="font-size: 18px"
                  matTooltip="{{ 'common.view' | translate }}"
                  (click)="viewFile(element)"
                  >remove_red_eye</mat-icon
                >
                <mat-icon
                  *ngIf="element.isOldFile"
                  style="font-size: 18px"
                  matTooltip="{{ 'DocumentUpload.downloadFile' | translate }}"
                  (click)="downloadFile(element)"
                  >file_download</mat-icon
                >
                <mat-icon
                  (click)="confirmDelete(element)"
                  style="font-size: 18px; color: red"
                  matTooltip="{{ 'DocumentUpload.removeFile' | translate }}"
                >
                  remove_circle
                </mat-icon>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="fileUploadColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: fileUploadColumns"></tr>
      </table>
    </div>

    <div class="right section-grey" style="margin: 7px">
      <button
        id="Upload Document"
        (click)="fileUploadDialog()"
        class="btnBlue"
        mat-mini-fab
        matTooltip="{{ 'DocumentUpload.uploadDocument' | translate }}"
      >
        <mat-icon 
          >backup</mat-icon
        >
      </button>
      &nbsp; &nbsp;
      <button
        id="Save Encounter"
        [disabled]="isSave"
        (click)="saveupload()"
        class="btnCyan"
        mat-mini-fab
        matTooltip="{{ 'payerInfo.save' | translate }}"
      >
        <mat-icon 
          >sim_card</mat-icon
        >
      </button>
    </div>
  </div>
</div>
